import React, { useContext } from 'react';
import { Route } from 'react-router-dom';
import './AnalyticsSection.css';
import AppContext from '../app/AppContext';
import SectionNav from '../organiserDashboard/SectionNav';
import ErrorBoundary from '../helpers/errorBoundary';
import UnpublishedOrgBanner from '../helpers/unpublishedOrgBanner';
import EventsReport from './EventsReport';

const Analytics = () => {
    const appContext = useContext(AppContext);

    return (
        <div className={`section-container ${!appContext.menuOpen && 'section-container-main-nav-closed'}`}>
            <SectionNav section="analytics" />
            {!appContext.selectedOrganisation.published && <UnpublishedOrgBanner />}
            <ErrorBoundary>
                <div
                    className={`section-content section-content-no-bottom-pad ${
                        !appContext.selectedOrganisation.published && 'section-content-with-banner'
                    }`}
                >
                    <Route path="/analytics/events-report">
                        <EventsReport />
                    </Route>
                </div>
            </ErrorBoundary>
        </div>
    );
};

export default Analytics;